<div class="loading" *ngIf="isLoading">Loading&#8230;</div>

<ag-grid-angular style="width: 100%; height: calc(100% - 17px)" [enableColResize]="true" [paginationPageSize]="30" [pagination]="true" class="ag-theme-alpine" [rowData]="rows" [columnDefs]="columnDefs" [enableSorting]="true" [enableFilter]="true" [suppressHorizontalScroll]="true"
    (columnResized)="onColumnResized($event)" (gridReady)="onGridReady($event)" [overlayNoRowsTemplate]='noDataText'>
</ag-grid-angular>